import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';
import fetchStatusCounts from '../GlobalFunction/Counts';



const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Account = () => {
  const names = ['Main Group', 'Groups', 'SubGroups', 'Ledgers', 'Billing Scheme', 'Bank Master'];

  const location = useLocation();
  const navigate = useNavigate();
  const [counts, setCounts] = useState([]);

  const permissions = useSelector(selectPermissions);

  const handleBoxClick = (path) => {
    navigate(path, { state: { permissions } });
  };

  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };
  const parentId = 39;

  useEffect(() => {
    const getCounts = async () => {
      const data = await fetchStatusCounts(parentId);
      setCounts(data);
    };
    getCounts();
  }, [parentId])


  const matchedItem = (moduleName) => {
    return counts.find(item => item.ModuleName === moduleName);
  };

  const matchMainGrp = matchedItem('Main Group');
  const matchGrps = matchedItem('Groups')
  const matchSubGrps = matchedItem('SubGroups');
  const matchLedgers = matchedItem('Ledgers');
  const matchBank = matchedItem('Bank Master');
  const matchOtherCharges = matchedItem('Other Charges');
  const matchBillingSch = matchedItem('Billing Scheme');


  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container sx={{
        width: "100%",
        maxWidth: "100%"
      }}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {hasModulePermission("Main Group") && matchMainGrp && (
              <BoxWithIcon
                totalCount={matchMainGrp.TotalCount}
                activeCount={matchMainGrp.ActiveCount}
                inactiveCount={matchMainGrp.InactiveCount}
                link={{ pathname: '/maingrptable' }}
                permissions={permissions}
                title="Main Group"
              />
            )}

            {hasModulePermission("Groups") && matchGrps && (
              <BoxWithIcon
                totalCount={matchGrps.TotalCount}
                activeCount={matchGrps.ActiveCount}
                inactiveCount={matchGrps.InactiveCount}
                link={{ pathname: '/groupmsttable' }}
                permissions={permissions}
                title="Groups"
              />
            )}

            {hasModulePermission("SubGroups") && matchSubGrps && (
              <BoxWithIcon
                totalCount={matchSubGrps.TotalCount}
                activeCount={matchSubGrps.ActiveCount}
                inactiveCount={matchSubGrps.InactiveCount}
                link={{ pathname: "/subgrpmsttable" }}
                permissions={permissions}
                title="SubGroups"
              />
            )}
            {/* {hasModulePermission("SubGroups") && ( */}
              <BoxWithIcon
                totalCount={0}
                activeCount={0}
                inactiveCount={0}
                link={{ pathname: "/accountsdetailes" }}
                permissions={permissions}
                title="Accounts"
              />
            {/* )} */}

            {hasModulePermission("Ledgers") && matchLedgers && (
              <BoxWithIcon
                totalCount={matchLedgers.TotalCount}
                activeCount={matchLedgers.ActiveCount}
                inactiveCount={matchLedgers.InactiveCount}
                link={{ pathname: "/ledgertable" }}
                permissions={permissions}
                title="Ledgers"
              />
            )}


            {hasModulePermission("Other Charges") && matchOtherCharges && (
              <BoxWithIcon
                totalCount={matchOtherCharges.TotalCount}
                activeCount={matchOtherCharges.ActiveCount}
                inactiveCount={matchOtherCharges.InactiveCount}
                link={{ pathname: "/otherchargestable" }}
                permissions={permissions}
                title="Other Charges"
              />
            )}

            {hasModulePermission("Bank Master") && matchBank && (
              <BoxWithIcon
                totalCount={matchBank.TotalCount}
                activeCount={matchBank.ActiveCount}
                inactiveCount={matchBank.InactiveCount}
                link={{ pathname: "/bank-table" }}
                permissions={permissions}
                title="Bank Master"
              />
            )}

            {/* {hasModulePermission("Billing Scheme") && matchBillingSch && (
              <BoxWithIcon
                totalCount={matchBillingSch.TotalCount}
                activeCount={matchBillingSch.ActiveCount}
                inactiveCount={matchBillingSch.InactiveCount}
                link="#"
                // link={{ pathname: "#" }}
                permissions={permissions}
                title="Billing Scheme"
              />)} */}

          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Account;
